import { StreamingCameraType } from "lib/types";
import { ReactNode, createContext, useState } from "react";

type SideviewContextType = {
  themeName: string;
  setThemeName: (newState: string) => void;
  viewData: any;
  setViewData: (newState: any) => void;
  openPanel: boolean;
  setOpenPanel: (newState: boolean) => void;
};

const initialStreamingCameras: StreamingCameraType[] = [];

const initialValue = {
  themeName: "",
  setThemeName: () => {},
  viewData: null,
  setViewData: () => {},
  openPanel: false,
  setOpenPanel: () => {},
};

export const SideviewContext = createContext<SideviewContextType>(initialValue);

export default function SideviewProvider({
  children,
}: {
  children?: ReactNode;
}) {
  const [themeName, setThemeName] = useState(initialValue.themeName);
  const [viewData, setViewData] = useState(initialValue.viewData);
  const [openPanel, setOpenPanel] = useState(initialValue.openPanel);

  return (
    <SideviewContext.Provider
      value={{
        themeName,
        setThemeName,
        viewData,
        setViewData,
        openPanel,
        setOpenPanel,
      }}
    >
      {children}
    </SideviewContext.Provider>
  );
}
